import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Accordion from './Accordion';

function AccordionContainer({ startPosition, children, drawerProps }) {
  const [openPosition, setOpenPosition] = useState(startPosition);

  const onOpenedChange = position => {
    if (openPosition !== position) {
      setOpenPosition(position);
    } else {
      setOpenPosition(null);
    }
  };

  return (
    <Accordion
      openPosition={openPosition}
      onOpenedChange={onOpenedChange}
      drawerProps={drawerProps}
    >
      {children}
    </Accordion>
  );
}

AccordionContainer.defaultProps = {
  startPosition: null,
  drawerProps: {},
};

AccordionContainer.propTypes = {
  startPosition: PropTypes.number,
  children: PropTypes.any.isRequired,
  drawerProps: PropTypes.object,
};

export default AccordionContainer;
